import { render, staticRenderFns } from "./SeriesItems.vue?vue&type=template&id=7a3569f7&scoped=true&"
import script from "./SeriesItems.vue?vue&type=script&lang=js&"
export * from "./SeriesItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3569f7",
  null
  
)

export default component.exports